<script setup lang="ts">
declare global {
  interface Window {
    hbspt?: {
      forms: {
        create: (config: Record<string, string>) => void
      }
    }
  }
}

useScriptTag(
  '//js.hsforms.net/forms/embed/v2.js',
  () => {
    if (typeof window !== 'undefined' && window.hbspt) {
      window.hbspt.forms.create({
        region: 'na1',
        portalId: '46684931',
        formId: '8133a05e-311b-45e1-abb2-9b9951711776',
        target: '#hubspot-form',
      })
    }
  },
  // {
  //   // async: true,
  //   // defer: true,
  //   once: true,
  // }
)
</script>

<template>
  <div>
    <div id="hubspot-form" />
  </div>
</template>
